var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.meta.allowAnonymous)?[_c('v-app',{attrs:{"id":"inspire"}},[_c('div',{staticClass:"app-container"},[_c('navigation',{attrs:{"toggle":_vm.drawer}}),_vm._v(" "),_c('v-main',[_c('toolbar',{on:{"toggleNavigationBar":function($event){_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('breadcrumbs'),_vm._v(" "),_c('router-view')],1)],1)])]:[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=62aef458&
// module id = null
// module chunks = 